import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { NAVIGATION_PANEL_DISPLAY_TYPE } from '../../../constants/analytics';

import { NavigationPanel } from './NavigationPanel';

import styles from './SidebarPageLayout.module.scss';

export function SidebarPageLayout(props) {
  const { children, hasStickyHeader, items } = props;
  const { supplierId } = useParams();
  const { displayType } = useSelector((state) => state.pageLayout.navigationPanel);

  const classes = ['container-fluid', styles.pageContainer];

  if (hasStickyHeader) {
    classes.push(styles.hasStickyHeader);
  }
  if (displayType === NAVIGATION_PANEL_DISPLAY_TYPE.COMPACT) {
    classes.push(styles.collapsed);
  }

  return (
    <>
      {items ? <NavigationPanel items={items} prefix={`/suppliers/${supplierId}`} /> : null}
      <div className={cn(classes)}>{children}</div>
    </>
  );
}

SidebarPageLayout.propTypes = {
  items: PropTypes.array,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  hasStickyHeader: PropTypes.bool,
};
